export const PARTNERS_LOGOS = [
    '/images/partners/1.png',
    '/images/partners/2.png',
    '/images/partners/3.png',
    '/images/partners/4.png',
    '/images/partners/5.png',
];
